module.exports = __webpack_public_path__ + "static/media/assistant-team.6d95dbaf.svg";